import { BOOLEAN_FEATURE_FLAGS, getFlag, getStringFlag, STRING_FEATURE_FLAGS, StringFeatureFlagName } from '~/hooks/useFlag'
import { DepartmentKey } from '~/store/slices/filterSlice'

import { BugReportFeatureFlagsSnapshot } from './useUserSupportMetadata'

export function getBrowserInfo(): string {
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : ''
    const browsers: [RegExp, string][] = [
        [/Edg\/(\S+)/, 'Edge'],
        [/OPR\/(\S+)/, 'Opera'],
        [/Chrome\/(\S+)/, 'Chrome'],
        [/Firefox\/(\S+)/, 'Firefox'],
        [/Version\/(\S+).*Safari/, 'Safari'],
    ]
    for (const [pattern, name] of browsers) {
        const match = ua.match(pattern)
        if (match) return `${name} ${match[1]}`
    }
    return '–'
}

export function getDepartmentLabel(departmentKey: DepartmentKey, departments: { id: number; name: string }[]): string {
    if (departmentKey === 'all') {
        return 'Alle'
    }
    return departments.find(d => d.id === departmentKey)?.name ?? String(departmentKey)
}

export function getFeatureFlagsSnapshot(): BugReportFeatureFlagsSnapshot {
    const flags: BugReportFeatureFlagsSnapshot = {}
    for (const key of Object.keys(BOOLEAN_FEATURE_FLAGS) as (keyof typeof BOOLEAN_FEATURE_FLAGS)[]) {
        flags[key] = getFlag(key)
    }
    for (const key of Object.keys(STRING_FEATURE_FLAGS) as StringFeatureFlagName[]) {
        flags[key] = getStringFlag(key)
    }
    return flags
}
